import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SearchObjectResult } from '../../shared/search-object-result.model';
import { URL_BASE } from '../../core/constants';
import { SortDirection } from '../../shared/sort-direction';
import { HttpUtils } from '../../shared/http-utils';
import { HotspotAlert } from './hotspot-alert.model';
import { HotspotAlertSearchCriteria } from './hotspot-alert-search-criteria.model';
import { CustomEncoder } from '../../shared/custom-encoder';
import { map } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable()
export class HotspotAlertService {

  private ALERTS_URI = 'hotspots/alerts';

  constructor(private http: HttpClient) {
  }

  public search(
    page: number, size: number, sortColumn: string, direction: SortDirection, criteria: HotspotAlertSearchCriteria
  ): Observable<SearchObjectResult<HotspotAlert>> {
    if (criteria.start_date) {
      criteria.start_date = moment(criteria.start_date).startOf('day').valueOf();
    }
    if (criteria.end_date) {
      criteria.end_date = moment(criteria.end_date).endOf('day').valueOf();
    }
    for (const key of Object.keys(criteria)) {
      if (!criteria[key]) {
        delete criteria[key];
      }
    }

    const headers = HttpUtils.createHeaders();
    const params  = new HttpParams({
      encoder: new CustomEncoder(),
      fromObject: {
        page: String(page),
        size: String(size),
        sort: sortColumn,
        direction,
        ...criteria
      }
    });

    const url = `${URL_BASE}/api/${this.ALERTS_URI}/search`;
    return this.http.get(url, { headers, params })
      .pipe(
        map(result => SearchObjectResult.fromDto(result, HotspotAlert.fromDto))
      );
  }

}
